export default (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18.7283 21.3013L11.0098 13.5828L3.29122 21.3013L0.718366 18.7285L8.43692 11.0099L0.718366 3.2914L3.29122 0.718549L11.0098 8.4371L18.7283 0.718549L21.3012 3.2914L13.5826 11.0099L21.3012 18.7285L18.7283 21.3013Z"
            fill="#660033"
        />
    </svg>
)
